import { render, staticRenderFns } from "./SidebarSlideMenu.vue?vue&type=template&id=03b14a40&scoped=true"
import script from "./SidebarSlideMenu.vue?vue&type=script&lang=js"
export * from "./SidebarSlideMenu.vue?vue&type=script&lang=js"
import style0 from "./SidebarSlideMenu.vue?vue&type=style&index=0&id=03b14a40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b14a40",
  null
  
)

export default component.exports